import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ChartComponent } from "ng-apexcharts";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

@Component({
  selector: "app-business-gift-orders",
  templateUrl: "./business-gift-orders.component.html",
  styleUrls: ["./business-gift-orders.component.scss"],
})
export class BusinessGiftOrdersComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;

  chartOptions: any = {
    series: [{ name: "Số đơn tặng", data: [3, 8, 5] }],
    chart: { type: "bar", height: 280, toolbar: { show: false } },
    plotOptions: { bar: { borderRadius: 4, columnWidth: "40%" } },
    dataLabels: { enabled: false },
    xaxis: { categories: ["Gói 3 tháng", "Gói 6 tháng", "Gói 12 tháng"] },
    yaxis: { title: { text: "Số đơn" } },
    fill: { colors: ["#5b73e8"] },
    tooltip: { y: { formatter: (val: number) => `${val} đơn` } },
    grid: { borderColor: "#f1f1f1" },
  };
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  listData = [];
  totalCount = 0;
  pageSize = 10;
  pageIndex = 1;
  params = "";
  searching = false;
  selectedFile: File | null = null;
  tableName = "customer-orders/giveaways";
  filter = {
    startDay: null,
    endDay: null,
    phone: null,
    terminalBankAcc: null,
    verificationStatus: [],
    deliveryMethod: null,
    referrer: null,
  };

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  statusList = [
    {
      label: "Tất cả",
      value: null,
    },
    {
      label: "Đủ điều kiện",
      value: ["pass", "pass_quay"],
    },
    {
      label: "Chưa đủ điều kiện",
      value: ["waiting"],
    },
    {
      label: "Đăng kí mới",
      value: ["pending"],
    },
    {
      label: "Từ chối",
      value: ["fail", "fraud"],
    },
  ];
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private eventService: EventService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.fetchData();
    
  }

  submitFilter() {
    const formatDate = (date: any | null) => {
      if (!date) return null;
      const d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    this.filter.startDay = formatDate(this.range.value.start);
    this.filter.endDay = formatDate(this.range.value.end);

    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      if ((this.filter as any)[key]) {
        this.params += `&${key}=${(this.filter as any)[key]}`;
      }
    });
    this.pageIndex = 1;
    this.searching = true;
    this.fetchData();
  }

  clearFilter() {
    this.filter = {
      startDay: null,
      endDay: null,
      phone: null,
      terminalBankAcc: null,
      verificationStatus: null,
      deliveryMethod: null,
      referrer: null,
    };
    this.range.reset();
    this.pageIndex = 1;
    this.searching = false;
    this.params = "";
    this.fetchData();
  }

  fetchData() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        `${this.tableName}?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res?.metadata?.results ?? [];
          this.totalCount =
            res?.metadata?.pagination?.totalCount ??
            res?.pagination?.totalCount ??
            0;
          this.eventService.setLoading(false);
        },
        error: () => {
          this.eventService.setLoading(false);
        },
      });
  }

  onChangePage(e: number) {
    this.pageIndex = e;
    this.fetchData();
  }

  exportExcel() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = `customer-orders/giveaways/export?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        const now = new Date();
        const formattedDate = now.toISOString().slice(0, 10).replace(/-/g, "");
        const fileName = `Danh sach don tang Loa_${formattedDate}.xlsx`;
        saveAs(res, fileName);
        this.eventService.setLoading(false);
      },
      error: () => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant("Xuất file lỗi")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  updateVerificationStatus(
    orderId: number,
    status: "pass" | "fail",
    reason?: string
  ) {
    this.eventService.setLoading(true);
    const body: any = { status };
    if (reason) body.reason = reason;

    this.http
      .post(`${this.tableName}/${orderId}/verification-status`, body)
      .subscribe({
        next: () => {
          this.apiService.showToastMobile(
            "success",
            this.translateService.instant(
              status === "pass" ? "Duyệt thành công" : "Từ chối thành công"
            )
          );
          this.eventService.setLoading(false);
          this.fetchData();
        },
        error: (err) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(err || "Cập nhật thất bại")
          );
          this.eventService.setLoading(false);
        },
      });
  }

  confirmApprove(orderId: number) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn duyệt đơn này?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateVerificationStatus(orderId, "pass");
      }
    });
  }
  confirmCancel(orderId: number) {
    Swal.fire({
      title: this.translateService.instant("Huỷ đơn"),
      text: this.translateService.instant("Nhập lý do Huỷ"),
      input: "text",
      inputPlaceholder: this.translateService.instant("Lý do Huỷ"),
      showCancelButton: true,
      confirmButtonColor: "#ff3d60",
      cancelButtonColor: "#74788d",
      confirmButtonText: this.translateService.instant("Huỷ đơn"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
      // 🔥 validate tại đây
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return this.translateService.instant("Vui lòng nhập lý do huỷ");
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value || "";
        const dataPost = {
          reason: reason,
        };
        this.http
          .post(`customer-orders/giveaways/${orderId}/cancel`, dataPost)
          .subscribe({
            next: () => {
              this.apiService.showToastMobile(
                "success",
                this.translateService.instant("Huỷ đơn thành công")
              );
              this.eventService.setLoading(false);
              this.fetchData();
            },
            error: (err) => {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant(err || "Huỷ thất bại")
              );
              this.eventService.setLoading(false);
            },
          });
      }
    });
  }
  confirmReject(orderId: number) {
    Swal.fire({
      title: this.translateService.instant("Từ chối đơn"),
      text: this.translateService.instant("Nhập lý do từ chối (tuỳ chọn)"),
      input: "select",
      inputOptions: {
        TK_khong_phai_HKD: this.translateService.instant(
          "Tài khoản không phải HKD"
        ),
        Khong_phai_chinh_chu: this.translateService.instant(
          "Không phải chính chủ"
        ),
        Chua_xac_thuc: this.translateService.instant("Chưa xác thực"),
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translateService.instant("Vui lòng chọn một lý do");
        }
      },
      inputPlaceholder: this.translateService.instant("Lý do từ chối"),
      showCancelButton: true,
      confirmButtonColor: "#ff3d60",
      cancelButtonColor: "#74788d",
      confirmButtonText: this.translateService.instant("Từ chối"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateVerificationStatus(
          orderId,
          "fail",
          (result.value as string) || undefined
        );
      }
    });
  }

  importFile() {
    if (!this.selectedFile) return;

    const formData = new FormData();
    formData.append("file", this.selectedFile, this.selectedFile.name);
    this.eventService.setLoading(true);

    this.http
      .post(`customer-orders/giveaways/status/import`, formData)
      .subscribe({
        next: () => {
          this.apiService.showToastMobile(
            "success",
            this.translateService.instant("Import thành công")
          );
          this.selectedFile = null;
          this.eventService.setLoading(false);
          this.fetchData();
        },
        error: (err) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(err ? err : "Import thất bại")
          );
          this.eventService.setLoading(false);
        },
      });
  }
}
